import React, { useState } from "react";
import { Link } from "react-router-dom";
import AuthLayout from "../../../Layout/AuthLayout";
import { useLocation, useNavigate } from "react-router-dom";
import { resetPassword } from "../../../services/User/Authentication";
import toast from "react-hot-toast";

const ResetPass = () => {
  const [newPassword, setNewPassword] = useState("");
  const [showNewPassword, setShowNewPassword] = useState(false);
  const [confirmPassword, setConfirmPassword] = useState("");
  const [showConfirmPassword, setShowConfirmPassword] = useState(false);
  const [errors, setErrors] = useState({});
  const location = useLocation();
  const navigate = useNavigate();
  const { token } = location.state || {};
  const [loading, setLoading] = useState(false);

  const validateForm = () => {
    let tempErrors = {};

    if (!newPassword) {
      tempErrors.newPassword = "New password is required";
    } else if (newPassword.length < 8) {
      tempErrors.newPassword = "Password must be at least 8 characters";
    }

    if (!confirmPassword) {
      tempErrors.confirmPassword = "Please confirm your password";
    } else if (newPassword !== confirmPassword) {
      tempErrors.confirmPassword = "Passwords do not match";
    }

    setErrors(tempErrors);
    return Object.keys(tempErrors).length === 0;
  };

  const handleSubmit = async (e) => {
    if (e && e.preventDefault) {
      e.preventDefault();
    }

    if (!validateForm()) return;

    setLoading(true);
    try {
      await resetPassword({
        token,
        new_password: newPassword,
        new_password_confirm: confirmPassword,
      });
      toast.success("Password reset successfully");
      navigate("/login");
    } catch (err) {
      toast.error(err.error || "Failed to reset password");
    } finally {
      setLoading(false);
    }
  };

  return (
    <AuthLayout>
      <h2 className="xl:text-[28px] md:text-2xl text-xl text-[var(--color-text)] mb-2">
        Reset Password
      </h2>
      <p className="xl:text-base md:text-sm text-xs text-[var(--color-text-muted)] mb-8">
        Enter and confirm your new password for your account
      </p>

      <form
        onSubmit={handleSubmit}
        className="bg-[var(--color-surface)] border border-[var(--color-border)] rounded-[var(--radius-md)] p-4 text-left"
      >
        <div className="mb-5">
          <label className="md:text-sm text-xs label-caps block mb-2" htmlFor="newPassword">
            NEW PASSWORD
          </label>
          <div className="relative">
            <input
              id="newPassword"
              type={showNewPassword ? "text" : "password"}
              placeholder="Enter new password"
              value={newPassword}
              onChange={(e) => {
                setNewPassword(e.target.value);
                setErrors((prev) => ({ ...prev, newPassword: "" }));
              }}
              className={`w-full py-3 pl-4 pr-10 bg-[var(--color-bg)] border rounded-[var(--radius-md)] text-[var(--color-text)] xl:text-base md:text-sm text-xs outline-none ${errors.newPassword
                ? "border-[rgba(255,69,0,0.25)]"
                : "border-[var(--color-border)]"
                }`}
              required
            />
            <button
              type="button"
              onClick={() => setShowNewPassword((v) => !v)}
              aria-label={showNewPassword ? "Hide password" : "Show password"}
              className="flex items-center justify-center absolute right-2 top-1/2 -translate-y-1/2 w-8 h-8 bg-transparent border-none text-[var(--color-text-muted)] xl:text-base md:text-sm text-xs cursor-pointer"
            >
              {showNewPassword ? "🙈" : "👁"}
            </button>
          </div>
          {errors.newPassword && (
            <p className="md:text-sm text-xs mt-1 text-[var(--color-accent-red)]">{errors.newPassword}</p>
          )}
        </div>

        <div className="mb-6">
          <label className="md:text-sm text-xs label-caps block mb-2" htmlFor="confirmPassword">
            CONFIRM PASSWORD
          </label>
          <div className="relative">
            <input
              id="confirmPassword"
              type={showConfirmPassword ? "text" : "password"}
              placeholder="Re-enter password"
              value={confirmPassword}
              onChange={(e) => {
                setConfirmPassword(e.target.value);
                setErrors((prev) => ({ ...prev, confirmPassword: "" }));
              }}
              className={`w-full py-3 pl-4 pr-10 bg-[var(--color-bg)] border rounded-[var(--radius-md)] text-[var(--color-text)] xl:text-base md:text-sm text-xs outline-none ${errors.confirmPassword
                ? "border-[rgba(255,69,0,0.25)]"
                : "border-[var(--color-border)]"
                }`}
              required
            />
            <button
              type="button"
              onClick={() => setShowConfirmPassword((v) => !v)}
              aria-label={showConfirmPassword ? "Hide password" : "Show password"}
              className="flex items-center justify-center absolute right-2 top-1/2 -translate-y-1/2 w-8 h-8 bg-transparent border-none text-[var(--color-text-muted)] xl:text-base md:text-sm text-xs cursor-pointer"
            >
              {showConfirmPassword ? "🙈" : "👁"}
            </button>
          </div>
          {errors.confirmPassword && (
            <p className="md:text-sm text-xs mt-1 text-[var(--color-accent-red)]">{errors.confirmPassword}</p>
          )}
        </div>

        <button
          type="submit"
          disabled={loading}
          className={`w-full xl:text-base md:text-sm text-xs bg-[var(--color-primary)] text-black border-none p-3 rounded-[var(--radius-md)] font-extrabold uppercase tracking-[0.06em] ${loading ? "cursor-not-allowed" : "cursor-pointer"}`}
        >
          {loading ? "Resetting Password..." : "Reset Password"}
        </button>
      </form>

      <p className="flex justify-center items-center gap-1 mt-6 xl:text-base md:text-sm text-xs text-[var(--color-text-muted)]">
        Back to{" "}
        <Link to="/login" className="text-[var(--color-primary)] font-extrabold">
          Login
        </Link>
      </p>
    </AuthLayout>
  );
};

export default ResetPass;
